<template>
  <div class="card home-card incentivos">
    <div class="home-card-header">
      <div class="incentivos-abas">
        <button
          v-for="aba in abas"
          :key="aba.chave"
          type="button"
          class="incentivos-aba"
          :class="{ 'incentivos-aba--ativa': aba.chave === ativa, 'incentivos-aba--unica': abas.length === 1 }"
          @click="ativa = aba.chave"
        >
          <i :class="aba.icone"></i> {{ aba.dados.titulo }}
        </button>
      </div>
      <small v-if="atual">
        <i class="far fa-clock mr-1"></i>Atualizado em {{ atual.apurado_em }}<template v-if="atual.base && atual.base !== 'FATURADO'"> ({{ atual.base.toLowerCase() }})</template>
      </small>
    </div>

    <div class="card-body">
      <v-podio-home v-if="ativa === 'podio'" :dados="podio" />
      <v-nivel-home v-else-if="ativa === 'nivel'" :dados="nivel" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    podio: { type: Object, default: null },
    nivel: { type: Object, default: null },
  },
  data() {
    return {
      ativa: this.podio ? "podio" : "nivel",
    };
  },
  computed: {
    abas() {
      const abas = [];
      if (this.podio) abas.push({ chave: "podio", icone: "fas fa-trophy incentivos-icone--podio", dados: this.podio });
      if (this.nivel) abas.push({ chave: "nivel", icone: "fas fa-gift incentivos-icone--nivel", dados: this.nivel });
      return abas;
    },
    atual() {
      const aba = this.abas.find((a) => a.chave === this.ativa);
      return aba ? aba.dados : null;
    },
  },
};
</script>

<style scoped>
.incentivos-abas {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.incentivos-aba {
  padding: 6px 14px;
  border: 1px solid #dee2e6;
  border-radius: 20px;
  background: #fff;
  color: #495057;
  font-weight: 600;
  cursor: pointer;
}
.incentivos-aba i {
  margin-right: 6px;
}
.incentivos-aba:hover {
  background: #f4f6f8;
}
.incentivos-aba--ativa,
.incentivos-aba--ativa:hover {
  border-color: #4f6f96;
  background: #4f6f96;
  color: #fff;
}
.incentivos-aba--ativa i {
  color: #fff !important;
}
/* uma aba so: vira o titulo do card */
.incentivos-aba--unica,
.incentivos-aba--unica:hover {
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  cursor: default;
}
.incentivos-aba--unica i.incentivos-icone--podio {
  color: #d4a72c !important;
}
.incentivos-aba--unica i.incentivos-icone--nivel {
  color: #8a6fb0 !important;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/distribuidor/Home/IncentivosHome.vue